import { INNER_API_ROUTES } from 'src/constants';

type LoginCredentials = {
  email: string;
  password: string;
};

export const loginFetch = async (credentials: LoginCredentials) => {
  const response = await fetch(INNER_API_ROUTES.LOGIN, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(credentials),
  });

  if (!response.ok) {
    const errorData = await response.json();
    throw new Error(errorData.message || 'Login failed');
  }

  return await response.json();
};
